import { Wifi, WifiOff, Signal, Loader2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { useHealthCheck } from '@/hooks/useApi';

export function ConnectionStatus() {
  const networkStatus = useNetworkStatus();
  const { data: health, isLoading, isError } = useHealthCheck();

  // Show loading state while checking health
  if (isLoading) {
    return (
      <Badge variant="secondary" className="gap-1">
        <Loader2 className="h-3 w-3 animate-spin" />
        Connecting...
      </Badge>
    );
  }

  // Show offline if no network connection
  if (!networkStatus.isOnline) {
    return (
      <Badge variant="destructive" className="gap-1">
        <WifiOff className="h-3 w-3" />
        Offline
      </Badge>
    );
  }

  // Show server error if health check failed
  if (isError || !health) {
    return (
      <Badge variant="destructive" className="gap-1">
        <WifiOff className="h-3 w-3" />
        Server Error
      </Badge>
    );
  }

  // Show slow connection warning
  if (networkStatus.isSlowConnection) {
    return (
      <Badge variant="secondary" className="gap-1 bg-orange-100 text-orange-800 hover:bg-orange-200 dark:bg-orange-900 dark:text-orange-100">
        <Signal className="h-3 w-3" />
        Slow Connection
      </Badge>
    );
  }

  // Show connected state
  return (
    <Badge variant="default" className="gap-1 bg-green-600 hover:bg-green-700 text-white">
      <Wifi className="h-3 w-3" />
      Connected
    </Badge>
  );
}